import { render, staticRenderFns } from "./SaiAccordionSecondary.vue?vue&type=template&id=628409c1&scoped=true"
import script from "./SaiAccordionSecondary.vue?vue&type=script&lang=js"
export * from "./SaiAccordionSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628409c1",
  null
  
)

export default component.exports